export default __webpack_public_path__ + "static/media/logo_p_small.e3015132.png";